import { Button, Card, CardActionArea, IconButton, CardHeader, Menu, MenuItem, CardActions, CardContent, CardMedia, Container, Divider, Fab, Grid, Typography, Avatar } from '@material-ui/core'
import { SettingsPowerRounded } from '@material-ui/icons'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import { AdminContextStore } from './AdminContext'
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AddIcon from '@material-ui/icons/Add';
import { ElevatedCircle } from '../Core/ElevatedCircle'
import FlexView from 'react-flexview/lib'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import adminApi from '../../api/admin.api'
import { awaitWithLoading } from '../../services/utils'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'

export const Agencies = () => {
    const adminContext = React.useContext(AdminContextStore)
    const history = useHistory()
    const [open, setOpen] = React.useState({open: false, agents: []})
    const [anchorEl, setAnchorEl] = React.useState(null);
    const[selectedAgencyCode, setSelectedAgencyCode] = useState('')

    const handleClick = (event, agencyCode) => {
        setAnchorEl(event.currentTarget);
        setSelectedAgencyCode(agencyCode)
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDeleteAgency = async (agencyCode) => {
        handleClose();
        let res = await awaitWithLoading(adminApi.deleteAgency(agencyCode))
        if(res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
                title: "Agency Deleted",
                body: "The agency has been deleted.",
                onClose: (val) => {
                    awaitWithLoading(adminContext.loadAgencies())
                },
            })
        }
        else 
            EventEmitterService.dispatch(EventKey.ShowError, res)
    }

    return <Container className="margin-top-basic">

        <div className="text-promotion blue bold">Agencies</div>
        <Divider />
        <FlexView>
        <Grid container spacing={3} className='margin-right-basic'>
        {adminContext.agencies.length == 0 && <Grid item> <div className="text-body bold black"> No Agencies yet.</div></Grid> }
            {adminContext.agencies.map(agency => 
            <Grid xs={12} md={6} key={agency.code} item style={{display: 'flex'}}>
            <Card style={{ height: '100%', width: '100%'}}>
                <CardHeader 
                    title={agency.name}
                    avatar={
                        <Avatar src={`${process.env.REACT_APP_AMAZAON_S3_BUCKET_URL}/broker-logos/favicons/${agency.code}_favicon.ico`}>
                        {agency.name[0]}
                        </Avatar>
                    }
                    subheader={agency.description}
                    action={<IconButton key={agency.code} onClick={e => handleClick(e ,agency.code)}> 
                                <MoreVertIcon />
                            </IconButton>} />
                <Menu
                    id={selectedAgencyCode}
                    elevation={1}
                    key={selectedAgencyCode}
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>
                    <MenuItem onClick={() => {history.push('/broker/admin/assignAgent', { partnership_code: selectedAgencyCode })}}>Assign an Agent</MenuItem>
                    <MenuItem onClick={() => {history.push('/broker/admin/createAgent', { partnership_code: selectedAgencyCode })}}>Add new Agent</MenuItem>
                    <MenuItem onClick={() => handleDeleteAgency(selectedAgencyCode)}>Delete Agency</MenuItem>
                </Menu>
                <CardActionArea style={{padding: 4}}>
                    <img style={{height: '60px'}} src={`${process.env.REACT_APP_AMAZAON_S3_BUCKET_URL}/broker-logos/logos/${agency.logo}`} />
                </CardActionArea>
                <CardActions>
                    <Grid container alignItems='center' justifyContent='space-between'>
                        <Button onClick={() => setOpen({open: true, agents: agency.agents})} size="small" color="primary">
                            View Agents
                        </Button>
                    </Grid>

                </CardActions>
            </Card></Grid>)}
        </Grid>
            <Fab onClick={() => history.push('/broker/admin/createAgency')} variant='extended' color="primary" style={{width: 200}}  aria-label="add" >
                <AddIcon />
                Add Agency
            </Fab>
        </FlexView>
        

        <SkywatchDialog 
            open={open.open} 
            circleHeader={<ElevatedCircle><AccountCircleIcon className="blue" fontSize="large" /></ElevatedCircle>}
            maxWidth={'sm'}
            closeDialog={() => setOpen({open: false, agents: []})}>
            <FlexView vAlignContent='center' column>
                <FlexView hAlignContent='center'>
                    <div className="blue bold text-title textcenter">Agents</div>
                </FlexView>
                <FlexView hAlignContent='left'>
                    {open.agents.length > 0 ? 
                    <ul>
                        {open.agents.map(k => <li key={k.email}>{k.email}</li>)}
                    </ul> : <span className="margin-top-medium margin-bottom-medium">There are no agents in this agency</span>}

                </FlexView>
            </FlexView>

        </SkywatchDialog>

    </Container>


}